<template>
  <div>

    <div class="row">
      <div class="col-lg-9 col-xxl-7 offset-xxl-1 py-3 d-print-none">

        <h2 class="mb-3">
          View Order: {{ order_id }}
          <div class="btn-group ml-1">
            <button class="btn btn-outline-secondary" @click.prevent="printOrder('full')">
              <i v-if="printing" class="fas fa-circle-notch fa-spin mr-1"></i>
              <i v-else class="fas fa-print mr-1"></i>
              Invoice
            </button>
            <button v-if="order" class="btn btn-primary" @click.prevent="printOrder('full')" :disabled="printing">
              Full
            </button>
            <button v-if="order" class="btn btn-primary" @click.prevent="printOrder('compact')" :disabled="printing">
              Compact
            </button>
          </div>
        </h2>

        <order-information v-if="order" :order="order"></order-information>

        <div v-if="order" class="card border-0 shadow-sm mb-3 table-responsive">
          <order-products :order="order" :prompt_fulfill="true"></order-products>
        </div>

      </div>
      <div class="col-lg-3 col-xxl-3 py-3">

        <order-history></order-history>

      </div>
    </div>

    <div id="order-print" style="display:none"></div>

  </div>
</template>

<script>
import axios from 'axios'
import OrderProducts from './partials/Products'
import OrderInformation from './partials/Information'
import OrderHistory from './partials/History'

export default {
  name: 'Order',
  components: {
    OrderHistory,
    OrderInformation,
    OrderProducts
  },
  props: ['order_id'],
  data () {
    return {
      fetching: false,
      printing: false,

      order: null,
      print_url: null
    }
  },
  mounted () {
    this.fetchOrder()
  },
  methods: {
    fetchOrder () {
      this.fetching = true

      axios.get('/orders/' + this.order_id).then((response) => {
        let order = response.data.data

        if (!order.order_status.code) {
          this.$toast.error('This order has an invalid status: ' + order.order_status.name)
          return false
        }

        this.order = order
        this.print_url = process.env.URLS_WEBSITE + '/orders/' + this.order_id + '/print?hash=' + order.hash
      }).catch(error => {
        let errorDescription = null

        if (error.response) {
          if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.message !== 'undefined') {
            errorDescription = error.response.data.message
          }
        } else {
          errorDescription = error.message
        }

        this.$toast.error(errorDescription || 'Failed to fetch the order')
      }).finally(() => {
        this.fetching = false
      })
    },

    printOrder (type) {
      this.printing = true

      axios.get('/orders/' + this.order_id + '/invoice?type=' + type).then((response) => {
        let printWindow = window.open('', 'Print', 'height=600,width=800')

        printWindow.document.write(atob(response.data.data))

        printWindow.document.close()
        printWindow.focus()
        setTimeout(() => {
          printWindow.print()
          printWindow.close()
        }, 1000)
      }).catch(error => {
        let errorMessage = 'Failed to print the order.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
      }).finally(() => {
        this.printing = false
      })
    }
  }
}
</script>

<style scoped>
#order-information {
  font-size: 14px;
}
#order-information .row:not(:last-child) {
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/order/Order.vue